export const management = {
  routes: [
    {
      path: "/management/report-template",
      component: () => import("../management-library-report-template-view"),
    },

    {
      path: "/management/report-template/edit/:id",
      component: () => import("../management-library-report-template-form"),
    },
    {
      path: "/management/report-template/create",
      component: () => import("../management-library-report-template-form"),
    },
  ],
};

export const fwsed = {
  routes: [
    {
      path: "/fwsed/report",
      component: () => import("../fwsed-report-view"),
    },
  ],
};
